import { useEffect } from "react";
import { useBlocker } from "react-router-dom";

/**
 * 저장하지 않은 변경사항이 있을 때 페이지 이탈을 가드한다.
 * - SPA 내 이동(GNB 탭 클릭, 뒤로가기 등): window.confirm 다이얼로그
 * - 브라우저 새로고침/탭 닫기: 브라우저 기본 confirm (beforeunload)
 *
 * 같은 경로 내 이동(쿼리 파라미터만 변경)은 가드하지 않는다.
 *
 * bypassRef: 의도적 저장-후-이동처럼 가드를 건너뛰어야 할 때 사용. navigate() 직전에
 * ref.current=true 로 두면, isDirty 가 아직 리렌더로 false 가 되기 전이어도 가드가 발동하지 않는다
 * (setState 로 비운 상태는 비동기라 navigate 시점엔 stale → ref 로 동기 우회).
 */
export function useUnsavedChangesGuard(
  isDirty: boolean,
  message: string,
  bypassRef?: { current: boolean },
) {
  useBlocker(({ currentLocation, nextLocation }) => {
    if (bypassRef?.current) return false;
    if (!isDirty) return false;
    if (currentLocation.pathname === nextLocation.pathname) return false;
    return !window.confirm(message);
  });

  useEffect(() => {
    if (!isDirty) return;
    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [isDirty]);
}
